(() => {
  if (window.__ltStorefrontCleanupInitialized) return;
  window.__ltStorefrontCleanupInitialized = true;

  const normalizedShippingCopy = window.ltaShipping.announcement;

  const normalizeAnnouncementCopy = (root = document) => {
    root.querySelectorAll('.announcement-bar__message span').forEach((node) => {
      const text = node.textContent.replace(/\s+/g, ' ').trim();
      const looksLikeShippingCopy =
        /nationwide overnight shipping/i.test(text) &&
        (/\$29/.test(text) || /\$39/.test(text) || /\$199/.test(text) || /\$350\+/.test(text));

      if (looksLikeShippingCopy) {
        node.textContent = normalizedShippingCopy;
      }
    });
  };

  const refreshCollectionSection = async () => {
    const currentSection = document.getElementById('shopify-section-main-collection-product-grid');
    if (!currentSection || currentSection.dataset.ltRefreshed === 'true') return;

    currentSection.dataset.ltRefreshed = 'true';

    try {
      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('section_id', 'main-collection-product-grid');

      const response = await fetch(sectionUrl.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) return;

      const html = await response.text();
      if (!html) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextSection = parsed.getElementById('shopify-section-main-collection-product-grid');
      if (!nextSection) return;

      HTMLUpdateUtility.viewTransition(currentSection, nextSection);
    } catch (error) {
      console.warn('Collection section refresh skipped.', error);
    }
  };

  const initializeStorefrontCleanup = () => {
    normalizeAnnouncementCopy();
    refreshCollectionSection().then(() => normalizeAnnouncementCopy());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStorefrontCleanup, { once: true });
  } else {
    initializeStorefrontCleanup();
  }
})();

